import config from 'services/table/const';
import Action from './action';
import { formatDate } from 'utilities/common';

let table = { ...config };
table.url = '/project';
table.columns = {
  customer_id: {
    title: 'Client',
    alias: 'customer.id',
    sortable: true,
    width: 250,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.customer?.name}
          </div>
          <small className="info text-uppercase">
            {row?.customer?.company_name}
          </small>
        </div>
      );
    },
  },

  quotation: {
    title: 'Quotation',
    sortable: true,
    width: 150,
    component: (row) => {
      return <div className="text-ellipsis">{row?.quotation ? row?.quotation?.code : '-'}</div>;
    },
  },

  name: {
    title: 'Nama',
    sortable: true,
    alias: 'name',
    width: 150,
    component: (row) => {
      return <div className="text-ellipsis">{row?.name || '-'}</div>;
    },
  },

  type: {
    title: 'Tipe',
    sortable: true,
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.type}</div>;
    },
  },

  invoice_method: {
    title: 'Invoice Method',
    sortable: true,
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.invoice_method}</div>;
    },
  },

  top: {
    title: 'TOP',
    sortable: true,
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.top} Hari</div>;
    },
  },

  start_monthly: {
    title: 'Periode',
    sortable: true,
    alias: 'start_monthly',
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.end_monthly !== '0001-01-01T00:00:00Z' ? `${formatDate(row?.start_monthly, 'YYYYMM')} - ${formatDate(row?.end_monthly, 'YYYYMM')}`: formatDate(row?.start_monthly, 'YYYYMM')}</div>;
    },
  },

  is_pkp: {
    title: 'PKP',
    sortable: true,
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.is_pkp ? 'Ya': 'Tidak'}</div>;
    },
  },

  ppn: {
    title: 'PPN',
    format_number: true,
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
  },

  pph: {
    title: 'PPH',
    format_number: true,
    sortable: false,
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
  },

  status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span className={`badge status-${row?.status}-lt ms-auto `}>
          {row?.status?.replace('_', ' ')}
        </span>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
